import React, { useEffect, useState } from 'react';
import API from "libs/api";
import { Modal, Button } from 'semantic-ui-react';
import { useParams } from "react-router-dom";
import { CHIPS, TEXTAREA } from "components/cmp_form/cmp_form";
import ICON from "components/cmp_icon/cmp_icon";



export default function CMP_NOTE_CREATE({ onOpen, onClose, onRefresh }) {

    //  variable declarations ------------------------------------------------------------------------------------------

    const { provider_id } = useParams();

    const [ var_data, set_data ] = useState({});
    const [ var_processing, set_processing ] = useState('inactive');



    //  event listeners ------------------------------------------------------------------------------------------------

    useEffect(() => {
        let data = {...var_data};
        data.provider_id = provider_id;
        data.category_id = '1578882f-e22f-4035-a161-de7d04928158';
        data.note = '';
        set_data(data);
    }, [ onOpen ]);



    //  async functions ------------------------------------------------------------------------------------------------

    async function post_note() {

        set_processing('processing');

        try {
            await API_post_note();
            set_processing('inactive');
            onRefresh();
            onClose();
        } catch (e) {
            set_processing('error');
            console.log(e);
        }
    }



    //  API calls ------------------------------------------------------------------------------------------------------

    function API_post_note(){
        return API.post('admin-providers', '/post-provider-note', { body: var_data});
    }



    //  event functions ------------------------------------------------------------------------------------------------

    function onChange_category(event){
        let data = { ...var_data };
        data.category_id = event;
        set_data(data);
    }

    function onChange_input(event){
        let data = {...var_data};
        data[event.target.name] = event.target.value;
        set_data(data);
    }

    function onClick_create(){
        post_note();
    }

    function onClick_cancel(){
        onClose();
    }



    // RENDER APP ======================================================================================================

    return (
        <Modal
            dimmer={'inverted'}
            onClose={onClose}
            open={onOpen}
            closeOnEscape={true}
            closeOnDimmerClick={true}
            id='cmp_note_create'>

            <div className='icon__wrapper'>
                <div className='icon'>
                    <ICON name='notes' className='icon' alt='contact icon'/>
                </div>
            </div>

            <div className="modal__header background--blue--500">
                <div className='text--md bold color--white'>Add a new note</div>
            </div>

            <div className='modal__content'>

                <CHIPS
                    label={'Category'}
                    onChange={onChange_category}
                    options={[
                        { value: '1578882f-e22f-4035-a161-de7d04928158', text: 'General' },
                        { value: 'd7f2d09f-8f93-4527-864a-10ef3bcf9f98', text: 'Sales' },
                        { value: '720a322f-23f0-45b4-8dcd-94c710167a27', text: 'Customer Support' },
                        { value: '6af01a93-038d-4024-8e3c-032671cb3cbe', text: 'Tech Support' },
                    ]}
                    value={var_data.category_id}
                />

                <TEXTAREA
                    errors={[]}
                    label='Note'
                    name='note'
                    onChange={onChange_input}
                    placeholder=''

                    value={var_data.note || null}
                />

            </div>

            <div className='modal__footer'>
                <Button className='primary' onClick={onClick_create}>Add</Button>
                <Button className='secondary' onClick={onClick_cancel}>Cancel</Button>
            </div>

        </Modal>
    );
}